<template>
  <vxe-modal v-model="visible" :title="$t('title.activeReplenishmentPickUp')" type="confirm" width="70%" @cancel="cancel" @confirm="confirm">
    <vxe-card>
      <template #title>
        <vxe-select v-model="query.storageRoomId" :options="storageRooms" placeholder="placeholder.pleaseSelectTargetStorageRoom" @change="refresh"/>
        <vxe-input v-model="query.no" placeholder="business.label.itemNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query.name" placeholder="business.label.itemName" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table
        ref="table"
        :data="data"
        :loading="loading"
        :min-height="500"
        @cell-dblclick="({row})=>dblclick(row)">
        <vxe-column :type="selectType" fixed="left" width="40"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName"/>
        <vxe-column field="pack.specification" title="business.label.specification"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
        <vxe-column field="invQuantity" title="business.label.existingInventory"/>
        <vxe-column field="quantity" title="business.label.sourceInventoryQuantity"/>
        <vxe-column field="inventoryLimit.lowerBound" title="business.label.lowerBound"/>
        <vxe-column field="inventoryLimit.upperBound" title="business.label.upperBound"/>
        <vxe-column field="obtainedQuantity" title="title.replenishmentQuantity"/>
        <vxe-column field="sourceStorageRoom.name" title="business.label.sourceStorageRoom"/>
        <vxe-column field="targetStorageRoom.name" title="business.label.targetStorageRoom"/>
        <vxe-column field="logicalStore.name" title="business.label.logicalStore" width="90"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </vxe-modal>
</template>
<script>
import { findAll } from '@/api/Api'
import { getOptions } from '@/utils/util'

export default {
  name: 'ActiveReplenishmentModal',
  data() {
    return {
      visible: false,
      loading: false,
      data: [],
      query: { no: '', name: '', storageRoomId: undefined },
      args: {},
      storageRooms: [],
      page: 1,
      size: 15,
      contentSize: 0
    }
  },
  created() {
    findAll('storageRoomFactory', { physical: true }).then(res => {
      if (res.success) {
        this.storageRooms = getOptions(res.result)
      }
    })
  },
  props: {
    selectType: {
      type: String,
      default: 'checkbox'
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    init(args) {
      this.query = { no: '', name: '', storageRoomId: undefined }
      this.data = []
      this.selectedRows = []
      this.page = 1
      if (args) {
        this.args = args
        Object.assign(this.query, args)
      }
    },
    open(args, e, selectedRows) {
      this.init(args)
      this.record = e
      if (this.selectType === 'checkbox' && selectedRows && selectedRows.length > 0) {
        this.selectedRows = JSON.parse(JSON.stringify(selectedRows))
      }
      this.visible = true
      this.refresh()
    },
    fetch() {
      this.loading = true
      const args = {
        ...this.args,
        'item.no': this.query.no,
        'item.name': this.query.name,
        'storageRoom.id': this.query.storageRoomId
      }
      findAll('initiativeReplenishInventoryFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = { 'owner.id': '', no: '', name: '', mnemonicCode: '' }
      Object.assign(this.query, this.args)
      this.refresh()
    },
    dblclick() {
      if (this.selectType === 'radio') {
        this.confirm()
      }
    },
    confirm() {
      let selectedRows
      if (this.selectType === 'radio') {
        let radioRow = this.$refs.table.getRadioRecord()
        if (radioRow !== null) {
          selectedRows = [radioRow]
        } else {
          selectedRows = []
        }
      } else {
        selectedRows = this.$refs.table.getCheckboxRecords()
      }
      this.$emit('change', selectedRows, this.record)
      this.visible = false
    },
    cancel() {
      this.visible = false
    }
  }
}
</script>